import { render } from "./HomeSlider.vue?vue&type=template&id=1f2e25f3&scoped=true"
import script from "./HomeSlider.vue?vue&type=script&lang=js"
export * from "./HomeSlider.vue?vue&type=script&lang=js"

import "./HomeSlider.vue?vue&type=style&index=0&id=1f2e25f3&lang=scss&scoped=true"

import exportComponent from "F:\\homework\\tokenza\\tokenza\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2e25f3"]])

export default __exports__